import { STRIPE_MAX_AMOUNT } from '@repo/lib';
import { z } from '../zod';

export const StripeAmountValidationSchema = z
  .number()
  .min(0)
  .max(STRIPE_MAX_AMOUNT, {
    message: `Number must be between 0 and ${STRIPE_MAX_AMOUNT.toLocaleString('en-US')}`,
  });
